export const ROWS_FOR_LOADING_STATE_LENGTH = 6;
export const dataForSkeleton = (primaryKey) => {
  return Array.from(
    { length: ROWS_FOR_LOADING_STATE_LENGTH },
    (_record, index) => ({
      [primaryKey]: index,
    })
  );
};
